module.exports = __webpack_public_path__ + "static/media/400121_01.d538b34f.png";